import { useEffect, useState } from 'react';
import { FiSave, FiUser, FiMail, FiShield } from 'react-icons/fi';
import { toast } from 'react-toastify';
import api from '../services/api';
import useUser from '../hooks/useUser';

const MyProfile = () => {
  const { fetchUser } = useUser();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    displayName: '',
    email: '',
    role: '',
    siteId: '',
  });

  useEffect(() => {
    const loadProfile = async () => {
      try {
        setLoading(true);
        const response = await api.get('/auth/profile');
        const profile = response.data?.data || {};
        setFormData({
          username: profile.username || '',
          displayName: profile.displayName || profile.fullName || profile.username || '',
          email: profile.email || '',
          role: profile.role || '',
          siteId: profile.siteId || '',
        });
      } catch {
        toast.error('Không thể tải thông tin cá nhân');
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setSaving(true);
      await api.put('/auth/profile', {
        displayName: formData.displayName,
        email: formData.email,
      });
      await fetchUser();
      toast.success('Cập nhật thông tin cá nhân thành công');
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || 'Không thể cập nhật thông tin cá nhân');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex min-h-[200px] items-center justify-center">
        <div className="h-7 w-7 animate-spin rounded-full border-2 border-slate-200 border-t-primary" />
      </div>
    );
  }

  return (
    <div className="max-w-2xl">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-slate-900">Thông tin cá nhân</h2>
        <p className="text-sm text-slate-500">Cập nhật display name và email tài khoản của bạn.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">Display name</label>
          <div className="flex items-center rounded-md border border-slate-300 bg-white px-3 py-2">
            <FiUser className="mr-2 text-slate-400" />
            <input
              type="text"
              className="w-full border-none bg-transparent text-sm text-slate-800 outline-none"
              value={formData.displayName}
              onChange={(event) => setFormData((prev) => ({ ...prev, displayName: event.target.value }))}
              required
            />
          </div>
        </div>

        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">Username</label>
          <div className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">
            {formData.username || '-'}
          </div>
        </div>

        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">Email</label>
          <div className="flex items-center rounded-md border border-slate-300 bg-white px-3 py-2">
            <FiMail className="mr-2 text-slate-400" />
            <input
              type="email"
              className="w-full border-none bg-transparent text-sm text-slate-800 outline-none"
              value={formData.email}
              onChange={(event) => setFormData((prev) => ({ ...prev, email: event.target.value }))}
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">Vai trò</label>
            <div className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">
              <FiShield className="mr-2 inline text-slate-400" />
              {formData.role || '-'}
            </div>
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">Site ID</label>
            <div className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">
              {formData.siteId || 'Global'}
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            disabled={saving}
            className="inline-flex items-center gap-1.5 rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-dark disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FiSave />
            {saving ? 'Đang lưu...' : 'Lưu thay đổi'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default MyProfile;